import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"; 
import { Helper } from "../helper";

export function AmountMaxValidator(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (Helper.isEmptyInputValue(control.value) || Helper.isEmptyInputValue(max)) {
            return null; // don't validate empty values to allow optional controls
        }
        const value = Helper.getAmountValue(control.value);
        // Controls with NaN values after parsing should be treated as not having a
        // maximum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-max
        return !isNaN(value) && value > max ? { AmountMaxValidatorKey: { 'max': max, 'actual': control.value } } : null;
    };
}